const MINECRAFT_ITEMS = [
  { value: 'acacia_boat', label: 'Acacia Boat' },
  { value: 'acacia_button', label: 'Acacia Button' },
  { value: 'acacia_chest_boat', label: 'Acacia Chest Boat' },
  { value: 'acacia_door', label: 'Acacia Door' },
  { value: 'acacia_fence', label: 'Acacia Fence' },
  { value: 'acacia_fence_gate', label: 'Acacia Fence Gate' },
  { value: 'acacia_hanging_sign', label: 'Acacia Hanging Sign' },
  { value: 'acacia_leaves', label: 'Acacia Leaves' },
  { value: 'acacia_log', label: 'Acacia Log' },
  { value: 'acacia_planks', label: 'Acacia Planks' },
  { value: 'acacia_pressure_plate', label: 'Acacia Pressure Plate' },
  { value: 'acacia_sapling', label: 'Acacia Sapling' },
  { value: 'acacia_sign', label: 'Acacia Sign' },
  { value: 'acacia_slab', label: 'Acacia Slab' },
  { value: 'acacia_stairs', label: 'Acacia Stairs' },
  { value: 'acacia_trapdoor', label: 'Acacia Trapdoor' },
  { value: 'acacia_wood', label: 'Acacia Wood' },
  { value: 'activator_rail', label: 'Activator Rail' },
  { value: 'allium', label: 'Allium' },
  { value: 'amethyst_block', label: 'Amethyst Block' },
  { value: 'amethyst_cluster', label: 'Amethyst Cluster' },
  { value: 'amethyst_shard', label: 'Amethyst Shard' },
  { value: 'ancient_debris', label: 'Ancient Debris' },
  { value: 'andesite', label: 'Andesite' },
  { value: 'andesite_slab', label: 'Andesite Slab' },
  { value: 'andesite_stairs', label: 'Andesite Stairs' },
  { value: 'andesite_wall', label: 'Andesite Wall' },
  { value: 'anvil', label: 'Anvil' },
  { value: 'apple', label: 'Apple' },
  { value: 'armor_stand', label: 'Armor Stand' },
  { value: 'arrow', label: 'Arrow' },
  { value: 'axolotl_bucket', label: 'Axolotl Bucket' },
  { value: 'azalea', label: 'Azalea' },
  { value: 'azalea_leaves', label: 'Azalea Leaves' },
  { value: 'azure_bluet', label: 'Azure Bluet' },
  { value: 'baked_potato', label: 'Baked Potato' },
  { value: 'bamboo', label: 'Bamboo' },
  { value: 'bamboo_block', label: 'Bamboo Block' },
  { value: 'bamboo_button', label: 'Bamboo Button' },
  { value: 'bamboo_chest_raft', label: 'Bamboo Chest Raft' },
  { value: 'bamboo_door', label: 'Bamboo Door' },
  { value: 'bamboo_fence', label: 'Bamboo Fence' },
  { value: 'bamboo_fence_gate', label: 'Bamboo Fence Gate' },
  { value: 'bamboo_hanging_sign', label: 'Bamboo Hanging Sign' },
  { value: 'bamboo_mosaic', label: 'Bamboo Mosaic' },
  { value: 'bamboo_mosaic_slab', label: 'Bamboo Mosaic Slab' },
  { value: 'bamboo_mosaic_stairs', label: 'Bamboo Mosaic Stairs' },
  { value: 'bamboo_planks', label: 'Bamboo Planks' },
  { value: 'bamboo_pressure_plate', label: 'Bamboo Pressure Plate' },
  { value: 'bamboo_raft', label: 'Bamboo Raft' },
  { value: 'bamboo_sign', label: 'Bamboo Sign' },
  { value: 'bamboo_slab', label: 'Bamboo Slab' },
  { value: 'bamboo_stairs', label: 'Bamboo Stairs' },
  { value: 'bamboo_trapdoor', label: 'Bamboo Trapdoor' },
  { value: 'barrel', label: 'Barrel' },
  { value: 'barrier', label: 'Barrier' },
  { value: 'basalt', label: 'Basalt' },
  { value: 'bat_spawn_egg', label: 'Bat Spawn Egg' },
  { value: 'beacon', label: 'Beacon' },
  { value: 'bedrock', label: 'Bedrock' },
  { value: 'bee_spawn_egg', label: 'Bee Spawn Egg' },
  { value: 'beef', label: 'Beef' },
  { value: 'beehive', label: 'Beehive' },
  { value: 'beetroot', label: 'Beetroot' },
  { value: 'beetroot_seeds', label: 'Beetroot Seeds' },
  { value: 'beetroot_soup', label: 'Beetroot Soup' },
  { value: 'bell', label: 'Bell' },
  { value: 'big_dripleaf', label: 'Big Dripleaf' },
  { value: 'birch_boat', label: 'Birch Boat' },
  { value: 'birch_button', label: 'Birch Button' },
  { value: 'birch_chest_boat', label: 'Birch Chest Boat' },
  { value: 'birch_door', label: 'Birch Door' },
  { value: 'birch_fence', label: 'Birch Fence' },
  { value: 'birch_fence_gate', label: 'Birch Fence Gate' },
  { value: 'birch_hanging_sign', label: 'Birch Hanging Sign' },
  { value: 'birch_leaves', label: 'Birch Leaves' },
  { value: 'birch_log', label: 'Birch Log' },
  { value: 'birch_planks', label: 'Birch Planks' },
  { value: 'birch_pressure_plate', label: 'Birch Pressure Plate' },
  { value: 'birch_sapling', label: 'Birch Sapling' },
  { value: 'birch_sign', label: 'Birch Sign' },
  { value: 'birch_slab', label: 'Birch Slab' },
  { value: 'birch_stairs', label: 'Birch Stairs' },
  { value: 'birch_trapdoor', label: 'Birch Trapdoor' },
  { value: 'birch_wood', label: 'Birch Wood' },
  { value: 'black_banner', label: 'Black Banner' },
  { value: 'black_bed', label: 'Black Bed' },
  { value: 'black_candle', label: 'Black Candle' },
  { value: 'black_carpet', label: 'Black Carpet' },
  { value: 'black_concrete', label: 'Black Concrete' },
  { value: 'black_concrete_powder', label: 'Black Concrete Powder' },
  { value: 'black_dye', label: 'Black Dye' },
  { value: 'black_glazed_terracotta', label: 'Black Glazed Terracotta' },
  { value: 'black_shulker_box', label: 'Black Shulker Box' },
  { value: 'black_stained_glass', label: 'Black Stained Glass' },
  { value: 'black_stained_glass_pane', label: 'Black Stained Glass Pane' },
  { value: 'black_terracotta', label: 'Black Terracotta' },
  { value: 'black_wool', label: 'Black Wool' },
  { value: 'blackstone', label: 'Blackstone' },
  { value: 'blackstone_slab', label: 'Blackstone Slab' },
  { value: 'blackstone_stairs', label: 'Blackstone Stairs' },
  { value: 'blackstone_wall', label: 'Blackstone Wall' },
  { value: 'blast_furnace', label: 'Blast Furnace' },
  { value: 'blaze_powder', label: 'Blaze Powder' },
  { value: 'blaze_rod', label: 'Blaze Rod' },
  { value: 'blaze_spawn_egg', label: 'Blaze Spawn Egg' },
  { value: 'blue_banner', label: 'Blue Banner' },
  { value: 'blue_bed', label: 'Blue Bed' },
  { value: 'blue_candle', label: 'Blue Candle' },
  { value: 'blue_carpet', label: 'Blue Carpet' },
  { value: 'blue_concrete', label: 'Blue Concrete' },
  { value: 'blue_concrete_powder', label: 'Blue Concrete Powder' },
  { value: 'blue_dye', label: 'Blue Dye' },
  { value: 'blue_glazed_terracotta', label: 'Blue Glazed Terracotta' },
  { value: 'blue_ice', label: 'Blue Ice' },
  { value: 'blue_orchid', label: 'Blue Orchid' },
  { value: 'blue_shulker_box', label: 'Blue Shulker Box' },
  { value: 'blue_stained_glass', label: 'Blue Stained Glass' },
  { value: 'blue_stained_glass_pane', label: 'Blue Stained Glass Pane' },
  { value: 'blue_terracotta', label: 'Blue Terracotta' },
  { value: 'blue_wool', label: 'Blue Wool' },
  { value: 'bolt_armor_trim_smithing_template', label: 'Bolt Armor Trim Smithing Template' },
  { value: 'bone', label: 'Bone' },
  { value: 'bone_block', label: 'Bone Block' },
  { value: 'bone_meal', label: 'Bone Meal' },
  { value: 'book', label: 'Book' },
  { value: 'bookshelf', label: 'Bookshelf' },
  { value: 'bow', label: 'Bow' },
  { value: 'bowl', label: 'Bowl' },
  { value: 'brain_coral', label: 'Brain Coral' },
  { value: 'brain_coral_block', label: 'Brain Coral Block' },
  { value: 'brain_coral_fan', label: 'Brain Coral Fan' },
  { value: 'bread', label: 'Bread' },
  { value: 'breeze_rod', label: 'Breeze Rod' },
  { value: 'breeze_spawn_egg', label: 'Breeze Spawn Egg' },
  { value: 'brewer_pottery_sherd', label: 'Brewer Pottery Sherd' },
  { value: 'brewing_stand', label: 'Brewing Stand' },
  { value: 'brick', label: 'Brick' },
  { value: 'brick_slab', label: 'Brick Slab' },
  { value: 'brick_stairs', label: 'Brick Stairs' },
  { value: 'brick_wall', label: 'Brick Wall' },
  { value: 'bricks', label: 'Bricks' },
  { value: 'brown_banner', label: 'Brown Banner' },
  { value: 'brown_bed', label: 'Brown Bed' },
  { value: 'brown_candle', label: 'Brown Candle' },
  { value: 'brown_carpet', label: 'Brown Carpet' },
  { value: 'brown_concrete', label: 'Brown Concrete' },
  { value: 'brown_concrete_powder', label: 'Brown Concrete Powder' },
  { value: 'brown_dye', label: 'Brown Dye' },
  { value: 'brown_glazed_terracotta', label: 'Brown Glazed Terracotta' },
  { value: 'brown_mushroom', label: 'Brown Mushroom' },
  { value: 'brown_mushroom_block', label: 'Brown Mushroom Block' },
  { value: 'brown_shulker_box', label: 'Brown Shulker Box' },
  { value: 'brown_stained_glass', label: 'Brown Stained Glass' },
  { value: 'brown_stained_glass_pane', label: 'Brown Stained Glass Pane' },
  { value: 'brown_terracotta', label: 'Brown Terracotta' },
  { value: 'brown_wool', label: 'Brown Wool' },
  { value: 'brush', label: 'Brush' },
  { value: 'bubble_coral', label: 'Bubble Coral' },
  { value: 'bubble_coral_block', label: 'Bubble Coral Block' },
  { value: 'bubble_coral_fan', label: 'Bubble Coral Fan' },
  { value: 'bucket', label: 'Bucket' },
  { value: 'budding_amethyst', label: 'Budding Amethyst' },
  { value: 'bundle', label: 'Bundle' },
  { value: 'cactus', label: 'Cactus' },
  { value: 'cake', label: 'Cake' },
  { value: 'calcite', label: 'Calcite' },
  { value: 'campfire', label: 'Campfire' },
  { value: 'candle', label: 'Candle' },
  { value: 'carrot', label: 'Carrot' },
  { value: 'carrot_on_a_stick', label: 'Carrot On A Stick' },
  { value: 'cartography_table', label: 'Cartography Table' },
  { value: 'carved_pumpkin', label: 'Carved Pumpkin' },
  { value: 'cauldron', label: 'Cauldron' },
  { value: 'chain', label: 'Chain' },
  { value: 'chain_command_block', label: 'Chain Command Block' },
  { value: 'chainmail_boots', label: 'Chainmail Boots' },
  { value: 'chainmail_chestplate', label: 'Chainmail Chestplate' },
  { value: 'chainmail_helmet', label: 'Chainmail Helmet' },
  { value: 'chainmail_leggings', label: 'Chainmail Leggings' },
  { value: 'charcoal', label: 'Charcoal' },
  { value: 'cherry_boat', label: 'Cherry Boat' },
  { value: 'cherry_button', label: 'Cherry Button' },
  { value: 'cherry_chest_boat', label: 'Cherry Chest Boat' },
  { value: 'cherry_door', label: 'Cherry Door' },
  { value: 'cherry_fence', label: 'Cherry Fence' },
  { value: 'cherry_fence_gate', label: 'Cherry Fence Gate' },
  { value: 'cherry_hanging_sign', label: 'Cherry Hanging Sign' },
  { value: 'cherry_leaves', label: 'Cherry Leaves' },
  { value: 'cherry_log', label: 'Cherry Log' },
  { value: 'cherry_planks', label: 'Cherry Planks' },
  { value: 'cherry_pressure_plate', label: 'Cherry Pressure Plate' },
  { value: 'cherry_sapling', label: 'Cherry Sapling' },
  { value: 'cherry_sign', label: 'Cherry Sign' },
  { value: 'cherry_slab', label: 'Cherry Slab' },
  { value: 'cherry_stairs', label: 'Cherry Stairs' },
  { value: 'cherry_trapdoor', label: 'Cherry Trapdoor' },
  { value: 'cherry_wood', label: 'Cherry Wood' },
  { value: 'chest', label: 'Chest' },
  { value: 'chest_minecart', label: 'Chest Minecart' },
  { value: 'chicken', label: 'Chicken' },
  { value: 'chicken_spawn_egg', label: 'Chicken Spawn Egg' },
  { value: 'chipped_anvil', label: 'Chipped Anvil' },
  { value: 'chiseled_bookshelf', label: 'Chiseled Bookshelf' },
  { value: 'chiseled_copper', label: 'Chiseled Copper' },
  { value: 'chiseled_deepslate', label: 'Chiseled Deepslate' },
  { value: 'chiseled_nether_bricks', label: 'Chiseled Nether Bricks' },
  { value: 'chiseled_polished_blackstone', label: 'Chiseled Polished Blackstone' },
  { value: 'chiseled_quartz_block', label: 'Chiseled Quartz Block' },
  { value: 'chiseled_red_sandstone', label: 'Chiseled Red Sandstone' },
  { value: 'chiseled_sandstone', label: 'Chiseled Sandstone' },
  { value: 'chiseled_stone_bricks', label: 'Chiseled Stone Bricks' },
  { value: 'chiseled_tuff', label: 'Chiseled Tuff' },
  { value: 'chiseled_tuff_bricks', label: 'Chiseled Tuff Bricks' },
  { value: 'chorus_flower', label: 'Chorus Flower' },
  { value: 'chorus_fruit', label: 'Chorus Fruit' },
  { value: 'chorus_plant', label: 'Chorus Plant' },
  { value: 'clay', label: 'Clay' },
  { value: 'clay_ball', label: 'Clay Ball' },
  { value: 'clock', label: 'Clock' },
  { value: 'coal', label: 'Coal' },
  { value: 'coal_block', label: 'Coal Block' },
  { value: 'coal_ore', label: 'Coal Ore' },
  { value: 'coarse_dirt', label: 'Coarse Dirt' },
  { value: 'cobbled_deepslate', label: 'Cobbled Deepslate' },
  { value: 'cobbled_deepslate_slab', label: 'Cobbled Deepslate Slab' },
  { value: 'cobbled_deepslate_stairs', label: 'Cobbled Deepslate Stairs' },
  { value: 'cobbled_deepslate_wall', label: 'Cobbled Deepslate Wall' },
  { value: 'cobblestone', label: 'Cobblestone' },
  { value: 'cobblestone_slab', label: 'Cobblestone Slab' },
  { value: 'cobblestone_stairs', label: 'Cobblestone Stairs' },
  { value: 'cobblestone_wall', label: 'Cobblestone Wall' },
  { value: 'cobweb', label: 'Cobweb' },
  { value: 'cocoa_beans', label: 'Cocoa Beans' },
  { value: 'cod', label: 'Cod' },
  { value: 'cod_bucket', label: 'Cod Bucket' },
  { value: 'command_block', label: 'Command Block' },
  { value: 'command_block_minecart', label: 'Command Block Minecart' },
  { value: 'comparator', label: 'Comparator' },
  { value: 'compass', label: 'Compass' },
  { value: 'composter', label: 'Composter' },
  { value: 'conduit', label: 'Conduit' },
  { value: 'cooked_beef', label: 'Cooked Beef' },
  { value: 'cooked_chicken', label: 'Cooked Chicken' },
  { value: 'cooked_cod', label: 'Cooked Cod' },
  { value: 'cooked_mutton', label: 'Cooked Mutton' },
  { value: 'cooked_porkchop', label: 'Cooked Porkchop' },
  { value: 'cooked_rabbit', label: 'Cooked Rabbit' },
  { value: 'cooked_salmon', label: 'Cooked Salmon' },
  { value: 'cookie', label: 'Cookie' },
  { value: 'copper_block', label: 'Copper Block' },
  { value: 'copper_bulb', label: 'Copper Bulb' },
  { value: 'copper_door', label: 'Copper Door' },
  { value: 'copper_grate', label: 'Copper Grate' },
  { value: 'copper_ingot', label: 'Copper Ingot' },
  { value: 'copper_ore', label: 'Copper Ore' },
  { value: 'copper_trapdoor', label: 'Copper Trapdoor' },
  { value: 'cornflower', label: 'Cornflower' },
  { value: 'cow_spawn_egg', label: 'Cow Spawn Egg' },
  { value: 'cracked_deepslate_bricks', label: 'Cracked Deepslate Bricks' },
  { value: 'cracked_deepslate_tiles', label: 'Cracked Deepslate Tiles' },
  { value: 'cracked_nether_bricks', label: 'Cracked Nether Bricks' },
  { value: 'cracked_polished_blackstone_bricks', label: 'Cracked Polished Blackstone Bricks' },
  { value: 'cracked_stone_bricks', label: 'Cracked Stone Bricks' },
  { value: 'crafter', label: 'Crafter' },
  { value: 'crafting_table', label: 'Crafting Table' },
  { value: 'creeper_banner_pattern', label: 'Creeper Banner Pattern' },
  { value: 'creeper_head', label: 'Creeper Head' },
  { value: 'creeper_spawn_egg', label: 'Creeper Spawn Egg' },
  { value: 'crimson_button', label: 'Crimson Button' },
  { value: 'crimson_door', label: 'Crimson Door' },
  { value: 'crimson_fence', label: 'Crimson Fence' },
  { value: 'crimson_fence_gate', label: 'Crimson Fence Gate' },
  { value: 'crimson_fungus', label: 'Crimson Fungus' },
  { value: 'crimson_hanging_sign', label: 'Crimson Hanging Sign' },
  { value: 'crimson_hyphae', label: 'Crimson Hyphae' },
  { value: 'crimson_nylium', label: 'Crimson Nylium' },
  { value: 'crimson_planks', label: 'Crimson Planks' },
  { value: 'crimson_pressure_plate', label: 'Crimson Pressure Plate' },
  { value: 'crimson_roots', label: 'Crimson Roots' },
  { value: 'crimson_sign', label: 'Crimson Sign' },
  { value: 'crimson_slab', label: 'Crimson Slab' },
  { value: 'crimson_stairs', label: 'Crimson Stairs' },
  { value: 'crimson_stem', label: 'Crimson Stem' },
  { value: 'crimson_trapdoor', label: 'Crimson Trapdoor' },
  { value: 'crossbow', label: 'Crossbow' },
  { value: 'crying_obsidian', label: 'Crying Obsidian' },
  { value: 'cut_copper', label: 'Cut Copper' },
  { value: 'cut_copper_slab', label: 'Cut Copper Slab' },
  { value: 'cut_copper_stairs', label: 'Cut Copper Stairs' },
  { value: 'cut_red_sandstone', label: 'Cut Red Sandstone' },
  { value: 'cut_red_sandstone_slab', label: 'Cut Red Sandstone Slab' },
  { value: 'cut_sandstone', label: 'Cut Sandstone' },
  { value: 'cut_sandstone_slab', label: 'Cut Sandstone Slab' },
  { value: 'cyan_banner', label: 'Cyan Banner' },
  { value: 'cyan_bed', label: 'Cyan Bed' },
  { value: 'cyan_candle', label: 'Cyan Candle' },
  { value: 'cyan_carpet', label: 'Cyan Carpet' },
  { value: 'cyan_concrete', label: 'Cyan Concrete' },
  { value: 'cyan_concrete_powder', label: 'Cyan Concrete Powder' },
  { value: 'cyan_dye', label: 'Cyan Dye' },
  { value: 'cyan_glazed_terracotta', label: 'Cyan Glazed Terracotta' },
  { value: 'cyan_shulker_box', label: 'Cyan Shulker Box' },
  { value: 'cyan_stained_glass', label: 'Cyan Stained Glass' },
  { value: 'cyan_stained_glass_pane', label: 'Cyan Stained Glass Pane' },
  { value: 'cyan_terracotta', label: 'Cyan Terracotta' },
  { value: 'cyan_wool', label: 'Cyan Wool' },
  { value: 'damaged_anvil', label: 'Damaged Anvil' },
  { value: 'dandelion', label: 'Dandelion' },
  { value: 'dark_oak_boat', label: 'Dark Oak Boat' },
  { value: 'dark_oak_button', label: 'Dark Oak Button' },
  { value: 'dark_oak_chest_boat', label: 'Dark Oak Chest Boat' },
  { value: 'dark_oak_door', label: 'Dark Oak Door' },
  { value: 'dark_oak_fence', label: 'Dark Oak Fence' },
  { value: 'dark_oak_fence_gate', label: 'Dark Oak Fence Gate' },
  { value: 'dark_oak_hanging_sign', label: 'Dark Oak Hanging Sign' },
  { value: 'dark_oak_leaves', label: 'Dark Oak Leaves' },
  { value: 'dark_oak_log', label: 'Dark Oak Log' },
  { value: 'dark_oak_planks', label: 'Dark Oak Planks' },
  { value: 'dark_oak_pressure_plate', label: 'Dark Oak Pressure Plate' },
  { value: 'dark_oak_sapling', label: 'Dark Oak Sapling' },
  { value: 'dark_oak_sign', label: 'Dark Oak Sign' },
  { value: 'dark_oak_slab', label: 'Dark Oak Slab' },
  { value: 'dark_oak_stairs', label: 'Dark Oak Stairs' },
  { value: 'dark_oak_trapdoor', label: 'Dark Oak Trapdoor' },
  { value: 'dark_oak_wood', label: 'Dark Oak Wood' },
  { value: 'dark_prismarine', label: 'Dark Prismarine' },
  { value: 'dark_prismarine_slab', label: 'Dark Prismarine Slab' },
  { value: 'dark_prismarine_stairs', label: 'Dark Prismarine Stairs' },
  { value: 'daylight_detector', label: 'Daylight Detector' },
  { value: 'dead_brain_coral_block', label: 'Dead Brain Coral Block' },
  { value: 'dead_bubble_coral_block', label: 'Dead Bubble Coral Block' },
  { value: 'dead_bush', label: 'Dead Bush' },
  { value: 'dead_fire_coral_block', label: 'Dead Fire Coral Block' },
  { value: 'dead_horn_coral_block', label: 'Dead Horn Coral Block' },
  { value: 'dead_tube_coral_block', label: 'Dead Tube Coral Block' },
  { value: 'decorated_pot', label: 'Decorated Pot' },
  { value: 'deepslate', label: 'Deepslate' },
  { value: 'deepslate_brick_slab', label: 'Deepslate Brick Slab' },
  { value: 'deepslate_brick_stairs', label: 'Deepslate Brick Stairs' },
  { value: 'deepslate_brick_wall', label: 'Deepslate Brick Wall' },
  { value: 'deepslate_bricks', label: 'Deepslate Bricks' },
  { value: 'deepslate_coal_ore', label: 'Deepslate Coal Ore' },
  { value: 'deepslate_copper_ore', label: 'Deepslate Copper Ore' },
  { value: 'deepslate_diamond_ore', label: 'Deepslate Diamond Ore' },
  { value: 'deepslate_emerald_ore', label: 'Deepslate Emerald Ore' },
  { value: 'deepslate_gold_ore', label: 'Deepslate Gold Ore' },
  { value: 'deepslate_iron_ore', label: 'Deepslate Iron Ore' },
  { value: 'deepslate_lapis_ore', label: 'Deepslate Lapis Ore' },
  { value: 'deepslate_redstone_ore', label: 'Deepslate Redstone Ore' },
  { value: 'deepslate_tile_slab', label: 'Deepslate Tile Slab' },
  { value: 'deepslate_tile_stairs', label: 'Deepslate Tile Stairs' },
  { value: 'deepslate_tile_wall', label: 'Deepslate Tile Wall' },
  { value: 'deepslate_tiles', label: 'Deepslate Tiles' },
  { value: 'detector_rail', label: 'Detector Rail' },
  { value: 'diamond', label: 'Diamond' },
  { value: 'diamond_axe', label: 'Diamond Axe' },
  { value: 'diamond_block', label: 'Diamond Block' },
  { value: 'diamond_boots', label: 'Diamond Boots' },
  { value: 'diamond_chestplate', label: 'Diamond Chestplate' },
  { value: 'diamond_helmet', label: 'Diamond Helmet' },
  { value: 'diamond_hoe', label: 'Diamond Hoe' },
  { value: 'diamond_horse_armor', label: 'Diamond Horse Armor' },
  { value: 'diamond_leggings', label: 'Diamond Leggings' },
  { value: 'diamond_ore', label: 'Diamond Ore' },
  { value: 'diamond_pickaxe', label: 'Diamond Pickaxe' },
  { value: 'diamond_shovel', label: 'Diamond Shovel' },
  { value: 'diamond_sword', label: 'Diamond Sword' },
  { value: 'diorite', label: 'Diorite' },
  { value: 'diorite_slab', label: 'Diorite Slab' },
  { value: 'diorite_stairs', label: 'Diorite Stairs' },
  { value: 'diorite_wall', label: 'Diorite Wall' },
  { value: 'dirt', label: 'Dirt' },
  { value: 'dirt_path', label: 'Dirt Path' },
  { value: 'dispenser', label: 'Dispenser' },
  { value: 'dolphin_spawn_egg', label: 'Dolphin Spawn Egg' },
  { value: 'dragon_breath', label: 'Dragon Breath' },
  { value: 'dragon_egg', label: 'Dragon Egg' },
  { value: 'dragon_head', label: 'Dragon Head' },
  { value: 'dried_kelp', label: 'Dried Kelp' },
  { value: 'dried_kelp_block', label: 'Dried Kelp Block' },
  { value: 'dripstone_block', label: 'Dripstone Block' },
  { value: 'dropper', label: 'Dropper' },
  { value: 'echo_shard', label: 'Echo Shard' },
  { value: 'egg', label: 'Egg' },
  { value: 'elytra', label: 'Elytra' },
  { value: 'emerald', label: 'Emerald' },
  { value: 'emerald_block', label: 'Emerald Block' },
  { value: 'emerald_ore', label: 'Emerald Ore' },
  { value: 'enchanted_book', label: 'Enchanted Book' },
  { value: 'enchanted_golden_apple', label: 'Enchanted Golden Apple' },
  { value: 'enchanting_table', label: 'Enchanting Table' },
  { value: 'end_crystal', label: 'End Crystal' },
  { value: 'end_portal_frame', label: 'End Portal Frame' },
  { value: 'end_rod', label: 'End Rod' },
  { value: 'end_stone', label: 'End Stone' },
  { value: 'end_stone_brick_slab', label: 'End Stone Brick Slab' },
  { value: 'end_stone_brick_stairs', label: 'End Stone Brick Stairs' },
  { value: 'end_stone_brick_wall', label: 'End Stone Brick Wall' },
  { value: 'end_stone_bricks', label: 'End Stone Bricks' },
  { value: 'ender_chest', label: 'Ender Chest' },
  { value: 'ender_eye', label: 'Ender Eye' },
  { value: 'ender_pearl', label: 'Ender Pearl' },
  { value: 'enderman_spawn_egg', label: 'Enderman Spawn Egg' },
  { value: 'endermite_spawn_egg', label: 'Endermite Spawn Egg' },
  { value: 'experience_bottle', label: 'Experience Bottle' },
  { value: 'exposed_chiseled_copper', label: 'Exposed Chiseled Copper' },
  { value: 'exposed_copper', label: 'Exposed Copper' },
  { value: 'exposed_copper_bulb', label: 'Exposed Copper Bulb' },
  { value: 'exposed_copper_door', label: 'Exposed Copper Door' },
  { value: 'exposed_copper_grate', label: 'Exposed Copper Grate' },
  { value: 'exposed_copper_trapdoor', label: 'Exposed Copper Trapdoor' },
  { value: 'exposed_cut_copper', label: 'Exposed Cut Copper' },
  { value: 'exposed_cut_copper_slab', label: 'Exposed Cut Copper Slab' },
  { value: 'exposed_cut_copper_stairs', label: 'Exposed Cut Copper Stairs' },
  { value: 'farmland', label: 'Farmland' },
  { value: 'feather', label: 'Feather' },
  { value: 'fermented_spider_eye', label: 'Fermented Spider Eye' },
  { value: 'fern', label: 'Fern' },
  { value: 'filled_map', label: 'Filled Map' },
  { value: 'fire_charge', label: 'Fire Charge' },
  { value: 'fire_coral', label: 'Fire Coral' },
  { value: 'fire_coral_block', label: 'Fire Coral Block' },
  { value: 'fire_coral_fan', label: 'Fire Coral Fan' },
  { value: 'firework_rocket', label: 'Firework Rocket' },
  { value: 'firework_star', label: 'Firework Star' },
  { value: 'fishing_rod', label: 'Fishing Rod' },
  { value: 'fletching_table', label: 'Fletching Table' },
  { value: 'flint', label: 'Flint' },
  { value: 'flint_and_steel', label: 'Flint And Steel' },
  { value: 'flow_armor_trim_smithing_template', label: 'Flow Armor Trim Smithing Template' },
  { value: 'flow_banner_pattern', label: 'Flow Banner Pattern' },
  { value: 'flower_pot', label: 'Flower Pot' },
  { value: 'flowering_azalea', label: 'Flowering Azalea' },
  { value: 'flowering_azalea_leaves', label: 'Flowering Azalea Leaves' },
  { value: 'fox_spawn_egg', label: 'Fox Spawn Egg' },
  { value: 'frogspawn', label: 'Frogspawn' },
  { value: 'furnace', label: 'Furnace' },
  { value: 'ghast_spawn_egg', label: 'Ghast Spawn Egg' },
  { value: 'ghast_tear', label: 'Ghast Tear' },
  { value: 'gilded_blackstone', label: 'Gilded Blackstone' },
  { value: 'glass', label: 'Glass' },
  { value: 'glass_bottle', label: 'Glass Bottle' },
  { value: 'glass_pane', label: 'Glass Pane' },
  { value: 'glistering_melon_slice', label: 'Glistering Melon Slice' },
  { value: 'globe_banner_pattern', label: 'Globe Banner Pattern' },
  { value: 'glow_berries', label: 'Glow Berries' },
  { value: 'glow_ink_sac', label: 'Glow Ink Sac' },
  { value: 'glow_item_frame', label: 'Glow Item Frame' },
  { value: 'glow_lichen', label: 'Glow Lichen' },
  { value: 'glow_squid_spawn_egg', label: 'Glow Squid Spawn Egg' },
  { value: 'glowstone', label: 'Glowstone' },
  { value: 'glowstone_dust', label: 'Glowstone Dust' },
  { value: 'goat_horn', label: 'Goat Horn' },
  { value: 'goat_spawn_egg', label: 'Goat Spawn Egg' },
  { value: 'gold_block', label: 'Gold Block' },
  { value: 'gold_ingot', label: 'Gold Ingot' },
  { value: 'gold_nugget', label: 'Gold Nugget' },
  { value: 'gold_ore', label: 'Gold Ore' },
  { value: 'golden_apple', label: 'Golden Apple' },
  { value: 'golden_axe', label: 'Golden Axe' },
  { value: 'golden_boots', label: 'Golden Boots' },
  { value: 'golden_carrot', label: 'Golden Carrot' },
  { value: 'golden_chestplate', label: 'Golden Chestplate' },
  { value: 'golden_helmet', label: 'Golden Helmet' },
  { value: 'golden_hoe', label: 'Golden Hoe' },
  { value: 'golden_horse_armor', label: 'Golden Horse Armor' },
  { value: 'golden_leggings', label: 'Golden Leggings' },
  { value: 'golden_pickaxe', label: 'Golden Pickaxe' },
  { value: 'golden_shovel', label: 'Golden Shovel' },
  { value: 'golden_sword', label: 'Golden Sword' },
  { value: 'granite', label: 'Granite' },
  { value: 'granite_slab', label: 'Granite Slab' },
  { value: 'granite_stairs', label: 'Granite Stairs' },
  { value: 'granite_wall', label: 'Granite Wall' },
  { value: 'grass_block', label: 'Grass Block' },
  { value: 'gravel', label: 'Gravel' },
  { value: 'gray_banner', label: 'Gray Banner' },
  { value: 'gray_bed', label: 'Gray Bed' },
  { value: 'gray_candle', label: 'Gray Candle' },
  { value: 'gray_carpet', label: 'Gray Carpet' },
  { value: 'gray_concrete', label: 'Gray Concrete' },
  { value: 'gray_concrete_powder', label: 'Gray Concrete Powder' },
  { value: 'gray_dye', label: 'Gray Dye' },
  { value: 'gray_glazed_terracotta', label: 'Gray Glazed Terracotta' },
  { value: 'gray_shulker_box', label: 'Gray Shulker Box' },
  { value: 'gray_stained_glass', label: 'Gray Stained Glass' },
  { value: 'gray_stained_glass_pane', label: 'Gray Stained Glass Pane' },
  { value: 'gray_terracotta', label: 'Gray Terracotta' },
  { value: 'gray_wool', label: 'Gray Wool' },
  { value: 'green_banner', label: 'Green Banner' },
  { value: 'green_bed', label: 'Green Bed' },
  { value: 'green_candle', label: 'Green Candle' },
  { value: 'green_carpet', label: 'Green Carpet' },
  { value: 'green_concrete', label: 'Green Concrete' },
  { value: 'green_concrete_powder', label: 'Green Concrete Powder' },
  { value: 'green_dye', label: 'Green Dye' },
  { value: 'green_glazed_terracotta', label: 'Green Glazed Terracotta' },
  { value: 'green_shulker_box', label: 'Green Shulker Box' },
  { value: 'green_stained_glass', label: 'Green Stained Glass' },
  { value: 'green_stained_glass_pane', label: 'Green Stained Glass Pane' },
  { value: 'green_terracotta', label: 'Green Terracotta' },
  { value: 'green_wool', label: 'Green Wool' },
  { value: 'grindstone', label: 'Grindstone' },
  { value: 'guardian_spawn_egg', label: 'Guardian Spawn Egg' },
  { value: 'gunpowder', label: 'Gunpowder' },
  { value: 'hanging_roots', label: 'Hanging Roots' },
  { value: 'hay_block', label: 'Hay Block' },
  { value: 'heart_of_the_sea', label: 'Heart Of The Sea' },
  { value: 'heavy_core', label: 'Heavy Core' },
  { value: 'heavy_weighted_pressure_plate', label: 'Heavy Weighted Pressure Plate' },
  { value: 'hoglin_spawn_egg', label: 'Hoglin Spawn Egg' },
  { value: 'honey_block', label: 'Honey Block' },
  { value: 'honey_bottle', label: 'Honey Bottle' },
  { value: 'honeycomb', label: 'Honeycomb' },
  { value: 'honeycomb_block', label: 'Honeycomb Block' },
  { value: 'hopper', label: 'Hopper' },
  { value: 'hopper_minecart', label: 'Hopper Minecart' },
  { value: 'horn_coral', label: 'Horn Coral' },
  { value: 'horn_coral_block', label: 'Horn Coral Block' },
  { value: 'horn_coral_fan', label: 'Horn Coral Fan' },
  { value: 'horse_spawn_egg', label: 'Horse Spawn Egg' },
  { value: 'ice', label: 'Ice' },
  { value: 'infested_chiseled_stone_bricks', label: 'Infested Chiseled Stone Bricks' },
  { value: 'infested_cobblestone', label: 'Infested Cobblestone' },
  { value: 'infested_cracked_stone_bricks', label: 'Infested Cracked Stone Bricks' },
  { value: 'infested_deepslate', label: 'Infested Deepslate' },
  { value: 'infested_mossy_stone_bricks', label: 'Infested Mossy Stone Bricks' },
  { value: 'infested_stone', label: 'Infested Stone' },
  { value: 'infested_stone_bricks', label: 'Infested Stone Bricks' },
  { value: 'ink_sac', label: 'Ink Sac' },
  { value: 'iron_axe', label: 'Iron Axe' },
  { value: 'iron_bars', label: 'Iron Bars' },
  { value: 'iron_block', label: 'Iron Block' },
  { value: 'iron_boots', label: 'Iron Boots' },
  { value: 'iron_chestplate', label: 'Iron Chestplate' },
  { value: 'iron_door', label: 'Iron Door' },
  { value: 'iron_golem_spawn_egg', label: 'Iron Golem Spawn Egg' },
  { value: 'iron_helmet', label: 'Iron Helmet' },
  { value: 'iron_hoe', label: 'Iron Hoe' },
  { value: 'iron_horse_armor', label: 'Iron Horse Armor' },
  { value: 'iron_ingot', label: 'Iron Ingot' },
  { value: 'iron_leggings', label: 'Iron Leggings' },
  { value: 'iron_nugget', label: 'Iron Nugget' },
  { value: 'iron_ore', label: 'Iron Ore' },
  { value: 'iron_pickaxe', label: 'Iron Pickaxe' },
  { value: 'iron_shovel', label: 'Iron Shovel' },
  { value: 'iron_sword', label: 'Iron Sword' },
  { value: 'iron_trapdoor', label: 'Iron Trapdoor' },
  { value: 'item_frame', label: 'Item Frame' },
  { value: 'jack_o_lantern', label: 'Jack O Lantern' },
  { value: 'jigsaw', label: 'Jigsaw' },
  { value: 'jukebox', label: 'Jukebox' },
  { value: 'jungle_boat', label: 'Jungle Boat' },
  { value: 'jungle_button', label: 'Jungle Button' },
  { value: 'jungle_chest_boat', label: 'Jungle Chest Boat' },
  { value: 'jungle_door', label: 'Jungle Door' },
  { value: 'jungle_fence', label: 'Jungle Fence' },
  { value: 'jungle_fence_gate', label: 'Jungle Fence Gate' },
  { value: 'jungle_hanging_sign', label: 'Jungle Hanging Sign' },
  { value: 'jungle_leaves', label: 'Jungle Leaves' },
  { value: 'jungle_log', label: 'Jungle Log' },
  { value: 'jungle_planks', label: 'Jungle Planks' },
  { value: 'jungle_pressure_plate', label: 'Jungle Pressure Plate' },
  { value: 'jungle_sapling', label: 'Jungle Sapling' },
  { value: 'jungle_sign', label: 'Jungle Sign' },
  { value: 'jungle_slab', label: 'Jungle Slab' },
  { value: 'jungle_stairs', label: 'Jungle Stairs' },
  { value: 'jungle_trapdoor', label: 'Jungle Trapdoor' },
  { value: 'jungle_wood', label: 'Jungle Wood' },
  { value: 'kelp', label: 'Kelp' },
  { value: 'knowledge_book', label: 'Knowledge Book' },
  { value: 'ladder', label: 'Ladder' },
  { value: 'lantern', label: 'Lantern' },
  { value: 'lapis_block', label: 'Lapis Block' },
  { value: 'lapis_lazuli', label: 'Lapis Lazuli' },
  { value: 'lapis_ore', label: 'Lapis Ore' },
  { value: 'large_amethyst_bud', label: 'Large Amethyst Bud' },
  { value: 'large_fern', label: 'Large Fern' },
  { value: 'lava_bucket', label: 'Lava Bucket' },
  { value: 'lead', label: 'Lead' },
  { value: 'leather', label: 'Leather' },
  { value: 'leather_boots', label: 'Leather Boots' },
  { value: 'leather_chestplate', label: 'Leather Chestplate' },
  { value: 'leather_helmet', label: 'Leather Helmet' },
  { value: 'leather_horse_armor', label: 'Leather Horse Armor' },
  { value: 'leather_leggings', label: 'Leather Leggings' },
  { value: 'lectern', label: 'Lectern' },
  { value: 'lever', label: 'Lever' },
  { value: 'light', label: 'Light' },
  { value: 'light_blue_banner', label: 'Light Blue Banner' },
  { value: 'light_blue_bed', label: 'Light Blue Bed' },
  { value: 'light_blue_candle', label: 'Light Blue Candle' },
  { value: 'light_blue_carpet', label: 'Light Blue Carpet' },
  { value: 'light_blue_concrete', label: 'Light Blue Concrete' },
  { value: 'light_blue_concrete_powder', label: 'Light Blue Concrete Powder' },
  { value: 'light_blue_dye', label: 'Light Blue Dye' },
  { value: 'light_blue_glazed_terracotta', label: 'Light Blue Glazed Terracotta' },
  { value: 'light_blue_shulker_box', label: 'Light Blue Shulker Box' },
  { value: 'light_blue_stained_glass', label: 'Light Blue Stained Glass' },
  { value: 'light_blue_stained_glass_pane', label: 'Light Blue Stained Glass Pane' },
  { value: 'light_blue_terracotta', label: 'Light Blue Terracotta' },
  { value: 'light_blue_wool', label: 'Light Blue Wool' },
  { value: 'light_gray_banner', label: 'Light Gray Banner' },
  { value: 'light_gray_bed', label: 'Light Gray Bed' },
  { value: 'light_gray_candle', label: 'Light Gray Candle' },
  { value: 'light_gray_carpet', label: 'Light Gray Carpet' },
  { value: 'light_gray_concrete', label: 'Light Gray Concrete' },
  { value: 'light_gray_concrete_powder', label: 'Light Gray Concrete Powder' },
  { value: 'light_gray_dye', label: 'Light Gray Dye' },
  { value: 'light_gray_glazed_terracotta', label: 'Light Gray Glazed Terracotta' },
  { value: 'light_gray_shulker_box', label: 'Light Gray Shulker Box' },
  { value: 'light_gray_stained_glass', label: 'Light Gray Stained Glass' },
  { value: 'light_gray_stained_glass_pane', label: 'Light Gray Stained Glass Pane' },
  { value: 'light_gray_terracotta', label: 'Light Gray Terracotta' },
  { value: 'light_gray_wool', label: 'Light Gray Wool' },
  { value: 'light_weighted_pressure_plate', label: 'Light Weighted Pressure Plate' },
  { value: 'lightning_rod', label: 'Lightning Rod' },
  { value: 'lilac', label: 'Lilac' },
  { value: 'lily_of_the_valley', label: 'Lily Of The Valley' },
  { value: 'lily_pad', label: 'Lily Pad' },
  { value: 'lime_banner', label: 'Lime Banner' },
  { value: 'lime_bed', label: 'Lime Bed' },
  { value: 'lime_candle', label: 'Lime Candle' },
  { value: 'lime_carpet', label: 'Lime Carpet' },
  { value: 'lime_concrete', label: 'Lime Concrete' },
  { value: 'lime_concrete_powder', label: 'Lime Concrete Powder' },
  { value: 'lime_dye', label: 'Lime Dye' },
  { value: 'lime_glazed_terracotta', label: 'Lime Glazed Terracotta' },
  { value: 'lime_shulker_box', label: 'Lime Shulker Box' },
  { value: 'lime_stained_glass', label: 'Lime Stained Glass' },
  { value: 'lime_stained_glass_pane', label: 'Lime Stained Glass Pane' },
  { value: 'lime_terracotta', label: 'Lime Terracotta' },
  { value: 'lime_wool', label: 'Lime Wool' },
  { value: 'lingering_potion', label: 'Lingering Potion' },
  { value: 'lodestone', label: 'Lodestone' },
  { value: 'loom', label: 'Loom' },
  { value: 'mace', label: 'Mace' },
  { value: 'magenta_banner', label: 'Magenta Banner' },
  { value: 'magenta_bed', label: 'Magenta Bed' },
  { value: 'magenta_candle', label: 'Magenta Candle' },
  { value: 'magenta_carpet', label: 'Magenta Carpet' },
  { value: 'magenta_concrete', label: 'Magenta Concrete' },
  { value: 'magenta_concrete_powder', label: 'Magenta Concrete Powder' },
  { value: 'magenta_dye', label: 'Magenta Dye' },
  { value: 'magenta_glazed_terracotta', label: 'Magenta Glazed Terracotta' },
  { value: 'magenta_shulker_box', label: 'Magenta Shulker Box' },
  { value: 'magenta_stained_glass', label: 'Magenta Stained Glass' },
  { value: 'magenta_stained_glass_pane', label: 'Magenta Stained Glass Pane' },
  { value: 'magenta_terracotta', label: 'Magenta Terracotta' },
  { value: 'magenta_wool', label: 'Magenta Wool' },
  { value: 'magma_block', label: 'Magma Block' },
  { value: 'magma_cream', label: 'Magma Cream' },
  { value: 'magma_cube_spawn_egg', label: 'Magma Cube Spawn Egg' },
  { value: 'mangrove_boat', label: 'Mangrove Boat' },
  { value: 'mangrove_button', label: 'Mangrove Button' },
  { value: 'mangrove_chest_boat', label: 'Mangrove Chest Boat' },
  { value: 'mangrove_door', label: 'Mangrove Door' },
  { value: 'mangrove_fence', label: 'Mangrove Fence' },
  { value: 'mangrove_fence_gate', label: 'Mangrove Fence Gate' },
  { value: 'mangrove_hanging_sign', label: 'Mangrove Hanging Sign' },
  { value: 'mangrove_leaves', label: 'Mangrove Leaves' },
  { value: 'mangrove_log', label: 'Mangrove Log' },
  { value: 'mangrove_planks', label: 'Mangrove Planks' },
  { value: 'mangrove_pressure_plate', label: 'Mangrove Pressure Plate' },
  { value: 'mangrove_propagule', label: 'Mangrove Propagule' },
  { value: 'mangrove_roots', label: 'Mangrove Roots' },
  { value: 'mangrove_sign', label: 'Mangrove Sign' },
  { value: 'mangrove_slab', label: 'Mangrove Slab' },
  { value: 'mangrove_stairs', label: 'Mangrove Stairs' },
  { value: 'mangrove_trapdoor', label: 'Mangrove Trapdoor' },
  { value: 'mangrove_wood', label: 'Mangrove Wood' },
  { value: 'map', label: 'Map' },
  { value: 'medium_amethyst_bud', label: 'Medium Amethyst Bud' },
  { value: 'melon', label: 'Melon' },
  { value: 'melon_seeds', label: 'Melon Seeds' },
  { value: 'melon_slice', label: 'Melon Slice' },
  { value: 'milk_bucket', label: 'Milk Bucket' },
  { value: 'minecart', label: 'Minecart' },
  { value: 'mojang_banner_pattern', label: 'Mojang Banner Pattern' },
  { value: 'moss_block', label: 'Moss Block' },
  { value: 'moss_carpet', label: 'Moss Carpet' },
  { value: 'mossy_cobblestone', label: 'Mossy Cobblestone' },
  { value: 'mossy_cobblestone_slab', label: 'Mossy Cobblestone Slab' },
  { value: 'mossy_cobblestone_stairs', label: 'Mossy Cobblestone Stairs' },
  { value: 'mossy_cobblestone_wall', label: 'Mossy Cobblestone Wall' },
  { value: 'mossy_stone_brick_slab', label: 'Mossy Stone Brick Slab' },
  { value: 'mossy_stone_brick_stairs', label: 'Mossy Stone Brick Stairs' },
  { value: 'mossy_stone_brick_wall', label: 'Mossy Stone Brick Wall' },
  { value: 'mossy_stone_bricks', label: 'Mossy Stone Bricks' },
  { value: 'mud', label: 'Mud' },
  { value: 'mud_brick_slab', label: 'Mud Brick Slab' },
  { value: 'mud_brick_stairs', label: 'Mud Brick Stairs' },
  { value: 'mud_brick_wall', label: 'Mud Brick Wall' },
  { value: 'mud_bricks', label: 'Mud Bricks' },
  { value: 'muddy_mangrove_roots', label: 'Muddy Mangrove Roots' },
  { value: 'mushroom_stem', label: 'Mushroom Stem' },
  { value: 'mushroom_stew', label: 'Mushroom Stew' },
  { value: 'music_disc_11', label: 'Music Disc 11' },
  { value: 'music_disc_13', label: 'Music Disc 13' },
  { value: 'music_disc_5', label: 'Music Disc 5' },
  { value: 'music_disc_blocks', label: 'Music Disc Blocks' },
  { value: 'music_disc_cat', label: 'Music Disc Cat' },
  { value: 'music_disc_chirp', label: 'Music Disc Chirp' },
  { value: 'music_disc_creator', label: 'Music Disc Creator' },
  { value: 'music_disc_creator_music_box', label: 'Music Disc Creator Music Box' },
  { value: 'music_disc_far', label: 'Music Disc Far' },
  { value: 'music_disc_mall', label: 'Music Disc Mall' },
  { value: 'music_disc_mellohi', label: 'Music Disc Mellohi' },
  { value: 'music_disc_otherside', label: 'Music Disc Otherside' },
  { value: 'music_disc_pigstep', label: 'Music Disc Pigstep' },
  { value: 'music_disc_precipice', label: 'Music Disc Precipice' },
  { value: 'music_disc_relic', label: 'Music Disc Relic' },
  { value: 'music_disc_stal', label: 'Music Disc Stal' },
  { value: 'music_disc_strad', label: 'Music Disc Strad' },
  { value: 'music_disc_wait', label: 'Music Disc Wait' },
  { value: 'music_disc_ward', label: 'Music Disc Ward' },
  { value: 'mutton', label: 'Mutton' },
  { value: 'mycelium', label: 'Mycelium' },
  { value: 'name_tag', label: 'Name Tag' },
  { value: 'nautilus_shell', label: 'Nautilus Shell' },
  { value: 'nether_brick', label: 'Nether Brick' },
  { value: 'nether_brick_fence', label: 'Nether Brick Fence' },
  { value: 'nether_brick_slab', label: 'Nether Brick Slab' },
  { value: 'nether_brick_stairs', label: 'Nether Brick Stairs' },
  { value: 'nether_brick_wall', label: 'Nether Brick Wall' },
  { value: 'nether_bricks', label: 'Nether Bricks' },
  { value: 'nether_gold_ore', label: 'Nether Gold Ore' },
  { value: 'nether_quartz_ore', label: 'Nether Quartz Ore' },
  { value: 'nether_sprouts', label: 'Nether Sprouts' },
  { value: 'nether_star', label: 'Nether Star' },
  { value: 'nether_wart', label: 'Nether Wart' },
  { value: 'nether_wart_block', label: 'Nether Wart Block' },
  { value: 'netherite_axe', label: 'Netherite Axe' },
  { value: 'netherite_block', label: 'Netherite Block' },
  { value: 'netherite_boots', label: 'Netherite Boots' },
  { value: 'netherite_chestplate', label: 'Netherite Chestplate' },
  { value: 'netherite_helmet', label: 'Netherite Helmet' },
  { value: 'netherite_hoe', label: 'Netherite Hoe' },
  { value: 'netherite_ingot', label: 'Netherite Ingot' },
  { value: 'netherite_leggings', label: 'Netherite Leggings' },
  { value: 'netherite_pickaxe', label: 'Netherite Pickaxe' },
  { value: 'netherite_scrap', label: 'Netherite Scrap' },
  { value: 'netherite_shovel', label: 'Netherite Shovel' },
  { value: 'netherite_sword', label: 'Netherite Sword' },
  { value: 'netherite_upgrade_smithing_template', label: 'Netherite Upgrade Smithing Template' },
  { value: 'netherrack', label: 'Netherrack' },
  { value: 'note_block', label: 'Note Block' },
  { value: 'oak_boat', label: 'Oak Boat' },
  { value: 'oak_button', label: 'Oak Button' },
  { value: 'oak_chest_boat', label: 'Oak Chest Boat' },
  { value: 'oak_door', label: 'Oak Door' },
  { value: 'oak_fence', label: 'Oak Fence' },
  { value: 'oak_fence_gate', label: 'Oak Fence Gate' },
  { value: 'oak_hanging_sign', label: 'Oak Hanging Sign' },
  { value: 'oak_leaves', label: 'Oak Leaves' },
  { value: 'oak_log', label: 'Oak Log' },
  { value: 'oak_planks', label: 'Oak Planks' },
  { value: 'oak_pressure_plate', label: 'Oak Pressure Plate' },
  { value: 'oak_sapling', label: 'Oak Sapling' },
  { value: 'oak_sign', label: 'Oak Sign' },
  { value: 'oak_slab', label: 'Oak Slab' },
  { value: 'oak_stairs', label: 'Oak Stairs' },
  { value: 'oak_trapdoor', label: 'Oak Trapdoor' },
  { value: 'oak_wood', label: 'Oak Wood' },
  { value: 'observer', label: 'Observer' },
  { value: 'obsidian', label: 'Obsidian' },
  { value: 'ocelot_spawn_egg', label: 'Ocelot Spawn Egg' },
  { value: 'ominous_bottle', label: 'Ominous Bottle' },
  { value: 'ominous_trial_key', label: 'Ominous Trial Key' },
  { value: 'orange_banner', label: 'Orange Banner' },
  { value: 'orange_bed', label: 'Orange Bed' },
  { value: 'orange_candle', label: 'Orange Candle' },
  { value: 'orange_carpet', label: 'Orange Carpet' },
  { value: 'orange_concrete', label: 'Orange Concrete' },
  { value: 'orange_concrete_powder', label: 'Orange Concrete Powder' },
  { value: 'orange_dye', label: 'Orange Dye' },
  { value: 'orange_glazed_terracotta', label: 'Orange Glazed Terracotta' },
  { value: 'orange_shulker_box', label: 'Orange Shulker Box' },
  { value: 'orange_stained_glass', label: 'Orange Stained Glass' },
  { value: 'orange_stained_glass_pane', label: 'Orange Stained Glass Pane' },
  { value: 'orange_terracotta', label: 'Orange Terracotta' },
  { value: 'orange_tulip', label: 'Orange Tulip' },
  { value: 'orange_wool', label: 'Orange Wool' },
  { value: 'oxeye_daisy', label: 'Oxeye Daisy' },
  { value: 'oxidized_chiseled_copper', label: 'Oxidized Chiseled Copper' },
  { value: 'oxidized_copper', label: 'Oxidized Copper' },
  { value: 'oxidized_copper_bulb', label: 'Oxidized Copper Bulb' },
  { value: 'oxidized_copper_door', label: 'Oxidized Copper Door' },
  { value: 'oxidized_copper_grate', label: 'Oxidized Copper Grate' },
  { value: 'oxidized_copper_trapdoor', label: 'Oxidized Copper Trapdoor' },
  { value: 'oxidized_cut_copper', label: 'Oxidized Cut Copper' },
  { value: 'oxidized_cut_copper_slab', label: 'Oxidized Cut Copper Slab' },
  { value: 'oxidized_cut_copper_stairs', label: 'Oxidized Cut Copper Stairs' },
  { value: 'packed_ice', label: 'Packed Ice' },
  { value: 'packed_mud', label: 'Packed Mud' },
  { value: 'painting', label: 'Painting' },
  { value: 'paper', label: 'Paper' },
  { value: 'pearlescent_froglight', label: 'Pearlescent Froglight' },
  { value: 'peony', label: 'Peony' },
  { value: 'petrified_oak_slab', label: 'Petrified Oak Slab' },
  { value: 'phantom_membrane', label: 'Phantom Membrane' },
  { value: 'phantom_spawn_egg', label: 'Phantom Spawn Egg' },
  { value: 'pig_spawn_egg', label: 'Pig Spawn Egg' },
  { value: 'piglin_banner_pattern', label: 'Piglin Banner Pattern' },
  { value: 'piglin_head', label: 'Piglin Head' },
  { value: 'piglin_spawn_egg', label: 'Piglin Spawn Egg' },
  { value: 'pillager_spawn_egg', label: 'Pillager Spawn Egg' },
  { value: 'pink_banner', label: 'Pink Banner' },
  { value: 'pink_bed', label: 'Pink Bed' },
  { value: 'pink_candle', label: 'Pink Candle' },
  { value: 'pink_carpet', label: 'Pink Carpet' },
  { value: 'pink_concrete', label: 'Pink Concrete' },
  { value: 'pink_concrete_powder', label: 'Pink Concrete Powder' },
  { value: 'pink_dye', label: 'Pink Dye' },
  { value: 'pink_glazed_terracotta', label: 'Pink Glazed Terracotta' },
  { value: 'pink_petals', label: 'Pink Petals' },
  { value: 'pink_shulker_box', label: 'Pink Shulker Box' },
  { value: 'pink_stained_glass', label: 'Pink Stained Glass' },
  { value: 'pink_stained_glass_pane', label: 'Pink Stained Glass Pane' },
  { value: 'pink_terracotta', label: 'Pink Terracotta' },
  { value: 'pink_tulip', label: 'Pink Tulip' },
  { value: 'pink_wool', label: 'Pink Wool' },
  { value: 'piston', label: 'Piston' },
  { value: 'pitcher_plant', label: 'Pitcher Plant' },
  { value: 'pitcher_pod', label: 'Pitcher Pod' },
  { value: 'player_head', label: 'Player Head' },
  { value: 'podzol', label: 'Podzol' },
  { value: 'pointed_dripstone', label: 'Pointed Dripstone' },
  { value: 'poisonous_potato', label: 'Poisonous Potato' },
  { value: 'polished_andesite', label: 'Polished Andesite' },
  { value: 'polished_andesite_slab', label: 'Polished Andesite Slab' },
  { value: 'polished_andesite_stairs', label: 'Polished Andesite Stairs' },
  { value: 'polished_basalt', label: 'Polished Basalt' },
  { value: 'polished_blackstone', label: 'Polished Blackstone' },
  { value: 'polished_blackstone_brick_slab', label: 'Polished Blackstone Brick Slab' },
  { value: 'polished_blackstone_brick_stairs', label: 'Polished Blackstone Brick Stairs' },
  { value: 'polished_blackstone_brick_wall', label: 'Polished Blackstone Brick Wall' },
  { value: 'polished_blackstone_bricks', label: 'Polished Blackstone Bricks' },
  { value: 'polished_blackstone_button', label: 'Polished Blackstone Button' },
  { value: 'polished_blackstone_pressure_plate', label: 'Polished Blackstone Pressure Plate' },
  { value: 'polished_blackstone_slab', label: 'Polished Blackstone Slab' },
  { value: 'polished_blackstone_stairs', label: 'Polished Blackstone Stairs' },
  { value: 'polished_blackstone_wall', label: 'Polished Blackstone Wall' },
  { value: 'polished_deepslate', label: 'Polished Deepslate' },
  { value: 'polished_deepslate_slab', label: 'Polished Deepslate Slab' },
  { value: 'polished_deepslate_stairs', label: 'Polished Deepslate Stairs' },
  { value: 'polished_deepslate_wall', label: 'Polished Deepslate Wall' },
  { value: 'polished_diorite', label: 'Polished Diorite' },
  { value: 'polished_diorite_slab', label: 'Polished Diorite Slab' },
  { value: 'polished_diorite_stairs', label: 'Polished Diorite Stairs' },
  { value: 'polished_granite', label: 'Polished Granite' },
  { value: 'polished_granite_slab', label: 'Polished Granite Slab' },
  { value: 'polished_granite_stairs', label: 'Polished Granite Stairs' },
  { value: 'polished_tuff', label: 'Polished Tuff' },
  { value: 'polished_tuff_slab', label: 'Polished Tuff Slab' },
  { value: 'polished_tuff_stairs', label: 'Polished Tuff Stairs' },
  { value: 'polished_tuff_wall', label: 'Polished Tuff Wall' },
  { value: 'popped_chorus_fruit', label: 'Popped Chorus Fruit' },
  { value: 'poppy', label: 'Poppy' },
  { value: 'porkchop', label: 'Porkchop' },
  { value: 'potato', label: 'Potato' },
  { value: 'potion', label: 'Potion' },
  { value: 'powder_snow_bucket', label: 'Powder Snow Bucket' },
  { value: 'powered_rail', label: 'Powered Rail' },
  { value: 'prismarine', label: 'Prismarine' },
  { value: 'prismarine_brick_slab', label: 'Prismarine Brick Slab' },
  { value: 'prismarine_brick_stairs', label: 'Prismarine Brick Stairs' },
  { value: 'prismarine_bricks', label: 'Prismarine Bricks' },
  { value: 'prismarine_crystals', label: 'Prismarine Crystals' },
  { value: 'prismarine_shard', label: 'Prismarine Shard' },
  { value: 'prismarine_slab', label: 'Prismarine Slab' },
  { value: 'prismarine_stairs', label: 'Prismarine Stairs' },
  { value: 'prismarine_wall', label: 'Prismarine Wall' },
  { value: 'pufferfish', label: 'Pufferfish' },
  { value: 'pufferfish_bucket', label: 'Pufferfish Bucket' },
  { value: 'pumpkin', label: 'Pumpkin' },
  { value: 'pumpkin_pie', label: 'Pumpkin Pie' },
  { value: 'pumpkin_seeds', label: 'Pumpkin Seeds' },
  { value: 'purple_banner', label: 'Purple Banner' },
  { value: 'purple_bed', label: 'Purple Bed' },
  { value: 'purple_candle', label: 'Purple Candle' },
  { value: 'purple_carpet', label: 'Purple Carpet' },
  { value: 'purple_concrete', label: 'Purple Concrete' },
  { value: 'purple_concrete_powder', label: 'Purple Concrete Powder' },
  { value: 'purple_dye', label: 'Purple Dye' },
  { value: 'purple_glazed_terracotta', label: 'Purple Glazed Terracotta' },
  { value: 'purple_shulker_box', label: 'Purple Shulker Box' },
  { value: 'purple_stained_glass', label: 'Purple Stained Glass' },
  { value: 'purple_stained_glass_pane', label: 'Purple Stained Glass Pane' },
  { value: 'purple_terracotta', label: 'Purple Terracotta' },
  { value: 'purple_wool', label: 'Purple Wool' },
  { value: 'purpur_block', label: 'Purpur Block' },
  { value: 'purpur_pillar', label: 'Purpur Pillar' },
  { value: 'purpur_slab', label: 'Purpur Slab' },
  { value: 'purpur_stairs', label: 'Purpur Stairs' },
  { value: 'quartz', label: 'Quartz' },
  { value: 'quartz_block', label: 'Quartz Block' },
  { value: 'quartz_bricks', label: 'Quartz Bricks' },
  { value: 'quartz_pillar', label: 'Quartz Pillar' },
  { value: 'quartz_slab', label: 'Quartz Slab' },
  { value: 'quartz_stairs', label: 'Quartz Stairs' },
  { value: 'rabbit', label: 'Rabbit' },
  { value: 'rabbit_foot', label: 'Rabbit Foot' },
  { value: 'rabbit_hide', label: 'Rabbit Hide' },
  { value: 'rabbit_spawn_egg', label: 'Rabbit Spawn Egg' },
  { value: 'rabbit_stew', label: 'Rabbit Stew' },
  { value: 'rail', label: 'Rail' },
  { value: 'raw_copper', label: 'Raw Copper' },
  { value: 'raw_copper_block', label: 'Raw Copper Block' },
  { value: 'raw_gold', label: 'Raw Gold' },
  { value: 'raw_gold_block', label: 'Raw Gold Block' },
  { value: 'raw_iron', label: 'Raw Iron' },
  { value: 'raw_iron_block', label: 'Raw Iron Block' },
  { value: 'recovery_compass', label: 'Recovery Compass' },
  { value: 'red_banner', label: 'Red Banner' },
  { value: 'red_bed', label: 'Red Bed' },
  { value: 'red_candle', label: 'Red Candle' },
  { value: 'red_carpet', label: 'Red Carpet' },
  { value: 'red_concrete', label: 'Red Concrete' },
  { value: 'red_concrete_powder', label: 'Red Concrete Powder' },
  { value: 'red_dye', label: 'Red Dye' },
  { value: 'red_glazed_terracotta', label: 'Red Glazed Terracotta' },
  { value: 'red_mushroom', label: 'Red Mushroom' },
  { value: 'red_mushroom_block', label: 'Red Mushroom Block' },
  { value: 'red_nether_brick_slab', label: 'Red Nether Brick Slab' },
  { value: 'red_nether_brick_stairs', label: 'Red Nether Brick Stairs' },
  { value: 'red_nether_brick_wall', label: 'Red Nether Brick Wall' },
  { value: 'red_nether_bricks', label: 'Red Nether Bricks' },
  { value: 'red_sand', label: 'Red Sand' },
  { value: 'red_sandstone', label: 'Red Sandstone' },
  { value: 'red_sandstone_slab', label: 'Red Sandstone Slab' },
  { value: 'red_sandstone_stairs', label: 'Red Sandstone Stairs' },
  { value: 'red_sandstone_wall', label: 'Red Sandstone Wall' },
  { value: 'red_shulker_box', label: 'Red Shulker Box' },
  { value: 'red_stained_glass', label: 'Red Stained Glass' },
  { value: 'red_stained_glass_pane', label: 'Red Stained Glass Pane' },
  { value: 'red_terracotta', label: 'Red Terracotta' },
  { value: 'red_tulip', label: 'Red Tulip' },
  { value: 'red_wool', label: 'Red Wool' },
  { value: 'redstone', label: 'Redstone' },
  { value: 'redstone_block', label: 'Redstone Block' },
  { value: 'redstone_lamp', label: 'Redstone Lamp' },
  { value: 'redstone_ore', label: 'Redstone Ore' },
  { value: 'redstone_torch', label: 'Redstone Torch' },
  { value: 'reinforced_deepslate', label: 'Reinforced Deepslate' },
  { value: 'repeater', label: 'Repeater' },
  { value: 'repeating_command_block', label: 'Repeating Command Block' },
  { value: 'respawn_anchor', label: 'Respawn Anchor' },
  { value: 'rooted_dirt', label: 'Rooted Dirt' },
  { value: 'rose_bush', label: 'Rose Bush' },
  { value: 'rotten_flesh', label: 'Rotten Flesh' },
  { value: 'saddle', label: 'Saddle' },
  { value: 'salmon', label: 'Salmon' },
  { value: 'salmon_bucket', label: 'Salmon Bucket' },
  { value: 'sand', label: 'Sand' },
  { value: 'sandstone', label: 'Sandstone' },
  { value: 'sandstone_slab', label: 'Sandstone Slab' },
  { value: 'sandstone_stairs', label: 'Sandstone Stairs' },
  { value: 'sandstone_wall', label: 'Sandstone Wall' },
  { value: 'scaffolding', label: 'Scaffolding' },
  { value: 'sculk', label: 'Sculk' },
  { value: 'sculk_catalyst', label: 'Sculk Catalyst' },
  { value: 'sculk_sensor', label: 'Sculk Sensor' },
  { value: 'sculk_shrieker', label: 'Sculk Shrieker' },
  { value: 'sculk_vein', label: 'Sculk Vein' },
  { value: 'sea_lantern', label: 'Sea Lantern' },
  { value: 'sea_pickle', label: 'Sea Pickle' },
  { value: 'seagrass', label: 'Seagrass' },
  { value: 'shears', label: 'Shears' },
  { value: 'sheep_spawn_egg', label: 'Sheep Spawn Egg' },
  { value: 'shield', label: 'Shield' },
  { value: 'short_grass', label: 'Short Grass' },
  { value: 'shroomlight', label: 'Shroomlight' },
  { value: 'shulker_box', label: 'Shulker Box' },
  { value: 'shulker_shell', label: 'Shulker Shell' },
  { value: 'shulker_spawn_egg', label: 'Shulker Spawn Egg' },
  { value: 'skeleton_head', label: 'Skeleton Head' },
  { value: 'skeleton_spawn_egg', label: 'Skeleton Spawn Egg' },
  { value: 'skull_banner_pattern', label: 'Skull Banner Pattern' },
  { value: 'slime_ball', label: 'Slime Ball' },
  { value: 'slime_block', label: 'Slime Block' },
  { value: 'slime_spawn_egg', label: 'Slime Spawn Egg' },
  { value: 'small_amethyst_bud', label: 'Small Amethyst Bud' },
  { value: 'small_dripleaf', label: 'Small Dripleaf' },
  { value: 'smithing_table', label: 'Smithing Table' },
  { value: 'smoker', label: 'Smoker' },
  { value: 'smooth_basalt', label: 'Smooth Basalt' },
  { value: 'smooth_quartz', label: 'Smooth Quartz' },
  { value: 'smooth_quartz_slab', label: 'Smooth Quartz Slab' },
  { value: 'smooth_quartz_stairs', label: 'Smooth Quartz Stairs' },
  { value: 'smooth_red_sandstone', label: 'Smooth Red Sandstone' },
  { value: 'smooth_red_sandstone_slab', label: 'Smooth Red Sandstone Slab' },
  { value: 'smooth_red_sandstone_stairs', label: 'Smooth Red Sandstone Stairs' },
  { value: 'smooth_sandstone', label: 'Smooth Sandstone' },
  { value: 'smooth_sandstone_slab', label: 'Smooth Sandstone Slab' },
  { value: 'smooth_sandstone_stairs', label: 'Smooth Sandstone Stairs' },
  { value: 'smooth_stone', label: 'Smooth Stone' },
  { value: 'smooth_stone_slab', label: 'Smooth Stone Slab' },
  { value: 'sniffer_egg', label: 'Sniffer Egg' },
  { value: 'sniffer_spawn_egg', label: 'Sniffer Spawn Egg' },
  { value: 'snow', label: 'Snow' },
  { value: 'snow_block', label: 'Snow Block' },
  { value: 'snowball', label: 'Snowball' },
  { value: 'soul_campfire', label: 'Soul Campfire' },
  { value: 'soul_lantern', label: 'Soul Lantern' },
  { value: 'soul_sand', label: 'Soul Sand' },
  { value: 'soul_soil', label: 'Soul Soil' },
  { value: 'soul_torch', label: 'Soul Torch' },
  { value: 'spawner', label: 'Spawner' },
  { value: 'spectral_arrow', label: 'Spectral Arrow' },
  { value: 'spider_eye', label: 'Spider Eye' },
  { value: 'spider_spawn_egg', label: 'Spider Spawn Egg' },
  { value: 'splash_potion', label: 'Splash Potion' },
  { value: 'sponge', label: 'Sponge' },
  { value: 'spore_blossom', label: 'Spore Blossom' },
  { value: 'spruce_boat', label: 'Spruce Boat' },
  { value: 'spruce_button', label: 'Spruce Button' },
  { value: 'spruce_chest_boat', label: 'Spruce Chest Boat' },
  { value: 'spruce_door', label: 'Spruce Door' },
  { value: 'spruce_fence', label: 'Spruce Fence' },
  { value: 'spruce_fence_gate', label: 'Spruce Fence Gate' },
  { value: 'spruce_hanging_sign', label: 'Spruce Hanging Sign' },
  { value: 'spruce_leaves', label: 'Spruce Leaves' },
  { value: 'spruce_log', label: 'Spruce Log' },
  { value: 'spruce_planks', label: 'Spruce Planks' },
  { value: 'spruce_pressure_plate', label: 'Spruce Pressure Plate' },
  { value: 'spruce_sapling', label: 'Spruce Sapling' },
  { value: 'spruce_sign', label: 'Spruce Sign' },
  { value: 'spruce_slab', label: 'Spruce Slab' },
  { value: 'spruce_stairs', label: 'Spruce Stairs' },
  { value: 'spruce_trapdoor', label: 'Spruce Trapdoor' },
  { value: 'spruce_wood', label: 'Spruce Wood' },
  { value: 'spyglass', label: 'Spyglass' },
  { value: 'squid_spawn_egg', label: 'Squid Spawn Egg' },
  { value: 'stick', label: 'Stick' },
  { value: 'sticky_piston', label: 'Sticky Piston' },
  { value: 'stone', label: 'Stone' },
  { value: 'stone_axe', label: 'Stone Axe' },
  { value: 'stone_brick_slab', label: 'Stone Brick Slab' },
  { value: 'stone_brick_stairs', label: 'Stone Brick Stairs' },
  { value: 'stone_brick_wall', label: 'Stone Brick Wall' },
  { value: 'stone_bricks', label: 'Stone Bricks' },
  { value: 'stone_button', label: 'Stone Button' },
  { value: 'stone_hoe', label: 'Stone Hoe' },
  { value: 'stone_pickaxe', label: 'Stone Pickaxe' },
  { value: 'stone_pressure_plate', label: 'Stone Pressure Plate' },
  { value: 'stone_shovel', label: 'Stone Shovel' },
  { value: 'stone_slab', label: 'Stone Slab' },
  { value: 'stone_stairs', label: 'Stone Stairs' },
  { value: 'stone_sword', label: 'Stone Sword' },
  { value: 'stonecutter', label: 'Stonecutter' },
  { value: 'stray_spawn_egg', label: 'Stray Spawn Egg' },
  { value: 'string', label: 'String' },
  { value: 'stripped_acacia_log', label: 'Stripped Acacia Log' },
  { value: 'stripped_acacia_wood', label: 'Stripped Acacia Wood' },
  { value: 'stripped_bamboo_block', label: 'Stripped Bamboo Block' },
  { value: 'stripped_birch_log', label: 'Stripped Birch Log' },
  { value: 'stripped_birch_wood', label: 'Stripped Birch Wood' },
  { value: 'stripped_cherry_log', label: 'Stripped Cherry Log' },
  { value: 'stripped_cherry_wood', label: 'Stripped Cherry Wood' },
  { value: 'stripped_crimson_hyphae', label: 'Stripped Crimson Hyphae' },
  { value: 'stripped_crimson_stem', label: 'Stripped Crimson Stem' },
  { value: 'stripped_dark_oak_log', label: 'Stripped Dark Oak Log' },
  { value: 'stripped_dark_oak_wood', label: 'Stripped Dark Oak Wood' },
  { value: 'stripped_jungle_log', label: 'Stripped Jungle Log' },
  { value: 'stripped_jungle_wood', label: 'Stripped Jungle Wood' },
  { value: 'stripped_mangrove_log', label: 'Stripped Mangrove Log' },
  { value: 'stripped_mangrove_wood', label: 'Stripped Mangrove Wood' },
  { value: 'stripped_oak_log', label: 'Stripped Oak Log' },
  { value: 'stripped_oak_wood', label: 'Stripped Oak Wood' },
  { value: 'stripped_spruce_log', label: 'Stripped Spruce Log' },
  { value: 'stripped_spruce_wood', label: 'Stripped Spruce Wood' },
  { value: 'stripped_warped_hyphae', label: 'Stripped Warped Hyphae' },
  { value: 'stripped_warped_stem', label: 'Stripped Warped Stem' },
  { value: 'structure_block', label: 'Structure Block' },
  { value: 'structure_void', label: 'Structure Void' },
  { value: 'sugar', label: 'Sugar' },
  { value: 'sugar_cane', label: 'Sugar Cane' },
  { value: 'sunflower', label: 'Sunflower' },
  { value: 'suspicious_gravel', label: 'Suspicious Gravel' },
  { value: 'suspicious_sand', label: 'Suspicious Sand' },
  { value: 'suspicious_stew', label: 'Suspicious Stew' },
  { value: 'sweet_berries', label: 'Sweet Berries' },
  { value: 'tadpole_bucket', label: 'Tadpole Bucket' },
  { value: 'tall_grass', label: 'Tall Grass' },
  { value: 'target', label: 'Target' },
  { value: 'terracotta', label: 'Terracotta' },
  { value: 'tinted_glass', label: 'Tinted Glass' },
  { value: 'tipped_arrow', label: 'Tipped Arrow' },
  { value: 'tnt', label: 'TNT' },
  { value: 'tnt_minecart', label: 'TNT Minecart' },
  { value: 'torch', label: 'Torch' },
  { value: 'torchflower', label: 'Torchflower' },
  { value: 'torchflower_seeds', label: 'Torchflower Seeds' },
  { value: 'totem_of_undying', label: 'Totem Of Undying' },
  { value: 'trapped_chest', label: 'Trapped Chest' },
  { value: 'trial_key', label: 'Trial Key' },
  { value: 'trial_spawner', label: 'Trial Spawner' },
  { value: 'trident', label: 'Trident' },
  { value: 'tripwire_hook', label: 'Tripwire Hook' },
  { value: 'tropical_fish', label: 'Tropical Fish' },
  { value: 'tropical_fish_bucket', label: 'Tropical Fish Bucket' },
  { value: 'tube_coral', label: 'Tube Coral' },
  { value: 'tube_coral_block', label: 'Tube Coral Block' },
  { value: 'tube_coral_fan', label: 'Tube Coral Fan' },
  { value: 'tuff', label: 'Tuff' },
  { value: 'tuff_brick_slab', label: 'Tuff Brick Slab' },
  { value: 'tuff_brick_stairs', label: 'Tuff Brick Stairs' },
  { value: 'tuff_brick_wall', label: 'Tuff Brick Wall' },
  { value: 'tuff_bricks', label: 'Tuff Bricks' },
  { value: 'tuff_slab', label: 'Tuff Slab' },
  { value: 'tuff_stairs', label: 'Tuff Stairs' },
  { value: 'tuff_wall', label: 'Tuff Wall' },
  { value: 'turtle_egg', label: 'Turtle Egg' },
  { value: 'turtle_helmet', label: 'Turtle Helmet' },
  { value: 'turtle_scute', label: 'Turtle Scute' },
  { value: 'turtle_spawn_egg', label: 'Turtle Spawn Egg' },
  { value: 'twisting_vines', label: 'Twisting Vines' },
  { value: 'vault', label: 'Vault' },
  { value: 'verdant_froglight', label: 'Verdant Froglight' },
  { value: 'vex_spawn_egg', label: 'Vex Spawn Egg' },
  { value: 'villager_spawn_egg', label: 'Villager Spawn Egg' },
  { value: 'vindicator_spawn_egg', label: 'Vindicator Spawn Egg' },
  { value: 'vine', label: 'Vine' },
  { value: 'wandering_trader_spawn_egg', label: 'Wandering Trader Spawn Egg' },
  { value: 'warden_spawn_egg', label: 'Warden Spawn Egg' },
  { value: 'warped_button', label: 'Warped Button' },
  { value: 'warped_door', label: 'Warped Door' },
  { value: 'warped_fence', label: 'Warped Fence' },
  { value: 'warped_fence_gate', label: 'Warped Fence Gate' },
  { value: 'warped_fungus', label: 'Warped Fungus' },
  { value: 'warped_fungus_on_a_stick', label: 'Warped Fungus On A Stick' },
  { value: 'warped_hanging_sign', label: 'Warped Hanging Sign' },
  { value: 'warped_hyphae', label: 'Warped Hyphae' },
  { value: 'warped_nylium', label: 'Warped Nylium' },
  { value: 'warped_planks', label: 'Warped Planks' },
  { value: 'warped_pressure_plate', label: 'Warped Pressure Plate' },
  { value: 'warped_roots', label: 'Warped Roots' },
  { value: 'warped_sign', label: 'Warped Sign' },
  { value: 'warped_slab', label: 'Warped Slab' },
  { value: 'warped_stairs', label: 'Warped Stairs' },
  { value: 'warped_stem', label: 'Warped Stem' },
  { value: 'warped_trapdoor', label: 'Warped Trapdoor' },
  { value: 'warped_wart_block', label: 'Warped Wart Block' },
  { value: 'water_bucket', label: 'Water Bucket' },
  { value: 'waxed_chiseled_copper', label: 'Waxed Chiseled Copper' },
  { value: 'waxed_copper_block', label: 'Waxed Copper Block' },
  { value: 'waxed_copper_bulb', label: 'Waxed Copper Bulb' },
  { value: 'waxed_copper_door', label: 'Waxed Copper Door' },
  { value: 'waxed_copper_grate', label: 'Waxed Copper Grate' },
  { value: 'waxed_copper_trapdoor', label: 'Waxed Copper Trapdoor' },
  { value: 'waxed_cut_copper', label: 'Waxed Cut Copper' },
  { value: 'waxed_cut_copper_slab', label: 'Waxed Cut Copper Slab' },
  { value: 'waxed_cut_copper_stairs', label: 'Waxed Cut Copper Stairs' },
  { value: 'waxed_exposed_chiseled_copper', label: 'Waxed Exposed Chiseled Copper' },
  { value: 'waxed_exposed_copper', label: 'Waxed Exposed Copper' },
  { value: 'waxed_exposed_copper_bulb', label: 'Waxed Exposed Copper Bulb' },
  { value: 'waxed_exposed_copper_door', label: 'Waxed Exposed Copper Door' },
  { value: 'waxed_exposed_copper_grate', label: 'Waxed Exposed Copper Grate' },
  { value: 'waxed_exposed_copper_trapdoor', label: 'Waxed Exposed Copper Trapdoor' },
  { value: 'waxed_exposed_cut_copper', label: 'Waxed Exposed Cut Copper' },
  { value: 'waxed_exposed_cut_copper_slab', label: 'Waxed Exposed Cut Copper Slab' },
  { value: 'waxed_exposed_cut_copper_stairs', label: 'Waxed Exposed Cut Copper Stairs' },
  { value: 'waxed_oxidized_chiseled_copper', label: 'Waxed Oxidized Chiseled Copper' },
  { value: 'waxed_oxidized_copper', label: 'Waxed Oxidized Copper' },
  { value: 'waxed_oxidized_copper_bulb', label: 'Waxed Oxidized Copper Bulb' },
  { value: 'waxed_oxidized_copper_door', label: 'Waxed Oxidized Copper Door' },
  { value: 'waxed_oxidized_copper_grate', label: 'Waxed Oxidized Copper Grate' },
  { value: 'waxed_oxidized_copper_trapdoor', label: 'Waxed Oxidized Copper Trapdoor' },
  { value: 'waxed_oxidized_cut_copper', label: 'Waxed Oxidized Cut Copper' },
  { value: 'waxed_oxidized_cut_copper_slab', label: 'Waxed Oxidized Cut Copper Slab' },
  { value: 'waxed_oxidized_cut_copper_stairs', label: 'Waxed Oxidized Cut Copper Stairs' },
  { value: 'waxed_weathered_chiseled_copper', label: 'Waxed Weathered Chiseled Copper' },
  { value: 'waxed_weathered_copper', label: 'Waxed Weathered Copper' },
  { value: 'waxed_weathered_copper_bulb', label: 'Waxed Weathered Copper Bulb' },
  { value: 'waxed_weathered_copper_door', label: 'Waxed Weathered Copper Door' },
  { value: 'waxed_weathered_copper_grate', label: 'Waxed Weathered Copper Grate' },
  { value: 'waxed_weathered_copper_trapdoor', label: 'Waxed Weathered Copper Trapdoor' },
  { value: 'waxed_weathered_cut_copper', label: 'Waxed Weathered Cut Copper' },
  { value: 'waxed_weathered_cut_copper_slab', label: 'Waxed Weathered Cut Copper Slab' },
  { value: 'waxed_weathered_cut_copper_stairs', label: 'Waxed Weathered Cut Copper Stairs' },
  { value: 'weathered_chiseled_copper', label: 'Weathered Chiseled Copper' },
  { value: 'weathered_copper', label: 'Weathered Copper' },
  { value: 'weathered_copper_bulb', label: 'Weathered Copper Bulb' },
  { value: 'weathered_copper_door', label: 'Weathered Copper Door' },
  { value: 'weathered_copper_grate', label: 'Weathered Copper Grate' },
  { value: 'weathered_copper_trapdoor', label: 'Weathered Copper Trapdoor' },
  { value: 'weathered_cut_copper', label: 'Weathered Cut Copper' },
  { value: 'weathered_cut_copper_slab', label: 'Weathered Cut Copper Slab' },
  { value: 'weathered_cut_copper_stairs', label: 'Weathered Cut Copper Stairs' },
  { value: 'weeping_vines', label: 'Weeping Vines' },
  { value: 'wet_sponge', label: 'Wet Sponge' },
  { value: 'wheat', label: 'Wheat' },
  { value: 'wheat_seeds', label: 'Wheat Seeds' },
  { value: 'white_banner', label: 'White Banner' },
  { value: 'white_bed', label: 'White Bed' },
  { value: 'white_candle', label: 'White Candle' },
  { value: 'white_carpet', label: 'White Carpet' },
  { value: 'white_concrete', label: 'White Concrete' },
  { value: 'white_concrete_powder', label: 'White Concrete Powder' },
  { value: 'white_dye', label: 'White Dye' },
  { value: 'white_glazed_terracotta', label: 'White Glazed Terracotta' },
  { value: 'white_shulker_box', label: 'White Shulker Box' },
  { value: 'white_stained_glass', label: 'White Stained Glass' },
  { value: 'white_stained_glass_pane', label: 'White Stained Glass Pane' },
  { value: 'white_terracotta', label: 'White Terracotta' },
  { value: 'white_tulip', label: 'White Tulip' },
  { value: 'white_wool', label: 'White Wool' },
  { value: 'wind_charge', label: 'Wind Charge' },
  { value: 'witch_spawn_egg', label: 'Witch Spawn Egg' },
  { value: 'wither_rose', label: 'Wither Rose' },
  { value: 'wither_skeleton_skull', label: 'Wither Skeleton Skull' },
  { value: 'wither_skeleton_spawn_egg', label: 'Wither Skeleton Spawn Egg' },
  { value: 'wolf_armor', label: 'Wolf Armor' },
  { value: 'wolf_spawn_egg', label: 'Wolf Spawn Egg' },
  { value: 'wooden_axe', label: 'Wooden Axe' },
  { value: 'wooden_hoe', label: 'Wooden Hoe' },
  { value: 'wooden_pickaxe', label: 'Wooden Pickaxe' },
  { value: 'wooden_shovel', label: 'Wooden Shovel' },
  { value: 'wooden_sword', label: 'Wooden Sword' },
  { value: 'writable_book', label: 'Writable Book' },
  { value: 'written_book', label: 'Written Book' },
  { value: 'yellow_banner', label: 'Yellow Banner' },
  { value: 'yellow_bed', label: 'Yellow Bed' },
  { value: 'yellow_candle', label: 'Yellow Candle' },
  { value: 'yellow_carpet', label: 'Yellow Carpet' },
  { value: 'yellow_concrete', label: 'Yellow Concrete' },
  { value: 'yellow_concrete_powder', label: 'Yellow Concrete Powder' },
  { value: 'yellow_dye', label: 'Yellow Dye' },
  { value: 'yellow_glazed_terracotta', label: 'Yellow Glazed Terracotta' },
  { value: 'yellow_shulker_box', label: 'Yellow Shulker Box' },
  { value: 'yellow_stained_glass', label: 'Yellow Stained Glass' },
  { value: 'yellow_stained_glass_pane', label: 'Yellow Stained Glass Pane' },
  { value: 'yellow_terracotta', label: 'Yellow Terracotta' },
  { value: 'yellow_wool', label: 'Yellow Wool' },
  { value: 'zombie_head', label: 'Zombie Head' },
  { value: 'zombie_spawn_egg', label: 'Zombie Spawn Egg' },
  { value: 'zombified_piglin_spawn_egg', label: 'Zombified Piglin Spawn Egg' },
];

export default MINECRAFT_ITEMS;
